<template>
	<div class="cbd">
		<div class="cbd__grid">
			<!-- Datos básicos -->
			<section class="cbd-card cbd-card--main">
				<p class="cbd-eyebrow">Datos básicos</p>

				<dl class="cbd-fields">
					<div class="cbd-field">
						<dt>Fecha de inscripción</dt>
						<dd v-if="!isLoading">
							{{ moment(basicData.oldest_join_date).format('DD-MM-YYYY') }}
						</dd>
						<dd v-else class="cbd-field__muted">—</dd>
					</div>

					<div class="cbd-field">
						<dt>Usuarios</dt>
						<dd>
							<div class="cbd-users">
								<SimpleButton v-for="user in allUsers" :key="user.user_id" class="user_button"
									@click="() => addUser(user.user_id, user.user_email)">
									{{ user.user_email }}
								</SimpleButton>
								<SimpleButton class="user_button add_user_button" @click="() => addUser(-1, '')">
									Agregar usuario +
								</SimpleButton>
							</div>
						</dd>
					</div>

					<div class="cbd-field">
						<dt>Libro general</dt>
						<dd>
							<div class="cbd-actions">
								<SimpleButton @click="() => openUpdateModalIdSheet()">
									Actualizar
								</SimpleButton>
								<SimpleButton v-if="basicData.general_book_id_sheet" class="is-secondary"
									@click="() => goToSheet()">
									Ir
								</SimpleButton>
							</div>
						</dd>
					</div>
				</dl>

				<div class="cbd-actions cbd-actions--wrap">
					<SimpleButton @click="() => openUpdateOperationsByUserModal()">
						Operaciones por usuario
					</SimpleButton>
					<SimpleButton @click="() => openUpdateUsernamePassModal()">
						Actualizar contraseña
					</SimpleButton>
					<SimpleButton @click="() => openUploadLedgerModal()">
						Subir mayor
					</SimpleButton>
				</div>
			</section>

			<!-- Contacto -->
			<section class="cbd-card">
				<p class="cbd-eyebrow">Contacto</p>

				<div class="cbd-logo">
					<img :src="basicData.logo" class="company_logo" v-if="basicData.logo" />
					<div class="cbd-logo__actions">
						<input type="file" ref="fileInput" accept="image/*" style="display: none;"
							@change="handleFileUpload" />
						<SimpleButton class="user_button add_user_button" @click="() => triggerFileDialog()">
							Subir logo
						</SimpleButton>
						<SimpleButton v-if="basicData.logo" class="btn_danger" @click="deleteImage()">
							X
						</SimpleButton>
					</div>
				</div>

				<div class="cbd-actions cbd-actions--stack">
					<SimpleButton @click="() => openEnviarCorreoTaxDocuments('sii')">
						<table>
							<tr>
								<td class="sii_b_msg"><span>Enviar correo documentos SII</span></td>
								<td class="sii_logo_td"><img :src="sii_logo" class="sii_logo" /></td>
							</tr>
						</table>
					</SimpleButton>
					<SimpleButton @click="() => openEnviarCorreoTaxDocuments('banks')">
						<table>
							<tr>
								<td class="sii_b_msg"><span>Enviar correo documentos Bancos</span></td>
								<td class="sii_logo_td"><img :src="bank_logo" class="sii_logo" /></td>
							</tr>
						</table>
					</SimpleButton>
				</div>
			</section>

			<!-- Reporte -->
			<section class="cbd-card">
				<p class="cbd-eyebrow">Reporte</p>

				<!-- Estado de la conexión SII (basicData.sii, derivado en backend por sii_status_selector — mismo semáforo que el listado). -->
				<div v-if="siiStatus" class="cbd-sii" :class="'cbd-sii--' + siiStatus.tone">
					<div class="cbd-sii__head">
						<span class="cbd-sii__dot"></span>
						<span class="cbd-sii__label">{{ siiStatus.label }}</span>
					</div>
					<p class="cbd-sii__detail">{{ basicData.sii.detail }}</p>
					<p v-if="basicData.sii.used_at" class="cbd-sii__meta">
						Última sincronización: {{ moment(basicData.sii.used_at).format('DD-MM-YYYY HH:mm') }}
					</p>
					<p v-if="basicData.sii.error_at" class="cbd-sii__meta">
						Último error: {{ moment(basicData.sii.error_at).format('DD-MM-YYYY HH:mm') }}
						<template v-if="basicData.sii.num_errors"> ({{ basicData.sii.num_errors }} intentos)</template>
					</p>
				</div>

				<div class="cbd-actions cbd-actions--stack">
					<SimpleButton @click="openGestionTerceros">
						<table>
							<tr>
								<td class="sii_b_msg"><span>Gestión de terceros</span></td>
								<td class="sii_logo_td">🔗</td>
							</tr>
						</table>
					</SimpleButton>
					<SimpleButton @click="() => openModalReloadReport('sii')">
						<table>
							<tr>
								<td class="sii_b_msg"><span>Recargar SII desde fintoc</span></td>
								<td class="sii_logo_td"><img :src="sii_logo" class="sii_logo" /></td>
							</tr>
						</table>
					</SimpleButton>
					<SimpleButton @click="() => openModalReloadReport('bank')">
						<table>
							<tr>
								<td class="sii_b_msg"><span>Recargar movimientos desde fintoc</span></td>
								<td class="sii_logo_td"><img :src="bank_logo" class="sii_logo" /></td>
							</tr>
						</table>
					</SimpleButton>
					<SimpleButton :disabled="loadingReloadDrive" @click="() => sendObligationsToDrive('sii')">
						<table>
							<tr>
								<td class="sii_b_msg"><span>Recargar drive para obligaciones</span></td>
								<td class="sii_logo_td"><img :src="sii_logo" class="sii_logo" /></td>
							</tr>
						</table>
					</SimpleButton>
					<SimpleButton :disabled="loadingReloadDrive" @click="() => sendObligationsToDrive('bank')">
						<table>
							<tr>
								<td class="sii_b_msg"><span>Recargar drive para movimientos</span></td>
								<td class="sii_logo_td"><img :src="bank_logo" class="sii_logo" /></td>
							</tr>
						</table>
					</SimpleButton>
					<SimpleButton :disabled="loadingReloadDrive"
						@click="() => sendObligationsToDrive('classification')">
						<table>
							<tr>
								<td class="sii_b_msg"><span>Recargar drive para clasificaciones</span></td>
								<td class="sii_logo_td"><img :src="sii_logo" class="sii_logo" /></td>
							</tr>
						</table>
					</SimpleButton>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
import { mapActions } from "vuex";
import { downloadMovementsToSheet, downloadObligationsToSheet, exportClassificationsToSheet } from "@/api/downloadObligationsToSheet";
import AssignUsers from "@/components/modals/AssignUsers";
import ChangeOperationsByUsers from "@/components/modals/ChangeOperationsByUsers";
import ChangeUsernamePass from "@/components/modals/ChangeUsernamePass";
import IdSheetUpdate from "@/components/modals/IdSheetUpdate";
import GestionTerceros from "@/components/modals/GestionTerceros";
import ReloadFintocByCompany from "@/components/modals/ReloadFintocByCompany";
import SimpleButton from "@/components/modals/SimpleButton";
import UploadFileAsUserModal from "@/components/modals/UploadFileAsUserModal";
import UploadLedger from "@/components/modals/UploadLedger";
import { consoleHandlerError, notificate } from "@/utils/message";
import moment from "moment";

export default {
	name: "CompanyInfoBasicData",
	components: {
		SimpleButton,
	},
	props: {
		basicData: {
			type: Object,
			required: true,
			default: () => ({})
		}
	},
	created() {
		const companyId = this.$route.query.companyId;
		this.companyRut = this.$route.query.companyRut;
		if (!companyId) {
			this.$router.push({ name: 'panel-analista' });
		}
		this.load_company_users();
	},
	data() {
		return {
			publicPath: "http://" + window.location.hostname,
			modalDefaultUpdateSheet: {
				parent: this,
				hasModalCard: true,
				customClass: "modal-class",
				canCancel: ["escape", "outside"],
			},
			allUsers: [],
			companyRut: '',
			loadingReloadDrive: false,
			isLoading: true,
		};
	},
	computed: {
		sii_logo: function () { return `${this.publicPath}/Logo_de_Servicio_de_Impuestos_Internos.png` },
		bank_logo: function () { return `${this.publicPath}/bank_logo.png` },
		siiStatus() {
			if (!this.basicData.sii) return null;
			const map = {
				OK: { label: "SII conectado", tone: "ok" },
				CONNECTING: { label: "SII conectando", tone: "progress" },
				LIKELY_BROKEN: { label: "SII a revisar", tone: "warn" },
				BROKEN: { label: "SII con problemas", tone: "bad" },
				NOT_APPLICABLE: { label: "Sin conexión SII", tone: "off" },
			};
			return map[this.basicData.sii.status] || map.NOT_APPLICABLE;
		},
	},
	methods: {
		...mapActions("analystCompany", [
			"deleteUploadedFile",
			"fetchUsersByCompany",
			"uploadCompanyFile",
		]),
		triggerFileDialog() {
			this.$refs.fileInput.click();
		},
		async deleteImage() {
			if (!this.basicData.logo) return;

			try {
				const data = await this.deleteUploadedFile(this.basicData.companyId);

				if (data['success']) {
					this.basicData.logo = null
				}
				this.$emit("file-uploaded", data);
			} catch (error) {
				console.error("Error uploading file: ", error);
			}
		},
		async handleFileUpload(event) {
			const file = event.target.files[0];
			if (!file) return;

			try {
				const data = await this.uploadCompanyFile({
					companyId: this.basicData.companyId,
					file,
				});

				if (data['success']) {
					this.basicData.logo = data['image']
				}
				this.$emit("file-uploaded", data);
			} catch (error) {
				console.error("Error uploading file:", error);
			}
		},
		load_company_users() {
			const companyId = this.$route.query.companyId;
			this.fetchUsersByCompany(companyId).then((data) => {
				this.allUsers = data;
			})
		},
		addUser(user_id, user_email) {
			this.$buefy.modal.open({
				...this.modalDefaultUpdateSheet,
				component: AssignUsers,
				canCancel: ['escape', 'button', 'outside'],
				props: {
					user_id: user_id,
					user_email: user_email,
					company_id: this.basicData.companyId,
				},
				events: {
					close: () => {
						this.load_company_users();
					}
				},
			});
		},
		moment(date) {
			return moment(date);
		},
		openUpdateModalIdSheet() {
			this.$buefy.modal.open({
				...this.modalDefaultUpdateSheet,
				component: IdSheetUpdate,
				props: {
					companyId: this.basicData.companyId,
					general_book_id_sheet: this.basicData.general_book_id_sheet
				},
				events: {
					"update-id-sheet": (newId) => {
						this.basicData.general_book_id_sheet = newId
					},
				},
			});
		},
		openEnviarCorreoTaxDocuments(which) {
			let allUsersByFileId = this.allUsers;
			if (allUsersByFileId == null || allUsersByFileId.length == 0) {
				alert('Error, no se encontraron usuarios para enviar un correo');
				return;
			}
			const message = which == 'sii' ? 'Enviar el correo con las obligaciones a' :
				'Enviar el correo con los movimientos bancarios a';
			this.$buefy.modal.open({
				...this.modalDefaultUpdateSheet,
				component: UploadFileAsUserModal,
				canCancel: ['escape', 'button', 'outside'],
				props: {
					idCompany: this.basicData.companyId,
					hideHistoricBtn: false,
					usersForEmail: this.allUsers,
					selectedFilesByUser: allUsersByFileId,
					noText: true,
					which: which,
					noTextMessage: message,
					sendMail: true,
				},
			});
		},
		openModalReloadReport(which) {
			this.$buefy.modal.open({
				...this.modalDefaultUpdateSheet,
				component: ReloadFintocByCompany,
				props: {
					rutCompany: this.companyRut,
					product: which,
				},
			});
		},
		openGestionTerceros() {
			this.$buefy.modal.open({
				...this.modalDefaultUpdateSheet,
				component: GestionTerceros,
				canCancel: ['escape', 'button', 'outside'],
				props: {
					companyId: this.basicData.companyId,
				},
			});
		},
		openUpdateOperationsByUserModal() {
			let allUsersByFileId = this.allUsers;
			if (allUsersByFileId == null || allUsersByFileId.length == 0) {
				alert('Error, no se encontraron usuarios para enviar un correo');
				return;
			}
			this.$buefy.modal.open({
				...this.modalDefaultUpdateSheet,
				component: ChangeOperationsByUsers,
				canCancel: ['escape', 'button', 'outside'],
				props: {
					idCompany: this.basicData.companyId,
				},
			});
		},
		sendObligationsToDrive(which) {
			let downloadToSheetFunc = null
			if (which == 'sii') {
				downloadToSheetFunc = downloadObligationsToSheet
			} else if (which == 'bank') {
				downloadToSheetFunc = downloadMovementsToSheet
			} else if (which == 'classification') {
				downloadToSheetFunc = exportClassificationsToSheet
			}

			this.loadingReloadDrive = true
			downloadToSheetFunc({
				rut_company: this.companyRut,
			}).then(({ data }) => {
				notificate(
					`<strong>Éxito!</strong><br>
					`+ data,
					"is-success is-light"
				);
			}).catch((error) => {
				consoleHandlerError({ error, empty: true });
			}).finally(() => {
				this.loadingReloadDrive = false
			})
		},
		goToSheet() {
			let parcialUrl = 'https://docs.google.com/spreadsheets/d/' + this.basicData.general_book_id_sheet + '/view'
			window.open(parcialUrl, "_blank");
		},
		openUpdateUsernamePassModal() {
			let allUsersByFileId = this.allUsers;
			if (allUsersByFileId == null || allUsersByFileId.length == 0) {
				alert('Error, no se encontraron usuarios para enviar un correo');
				return;
			}
			this.$buefy.modal.open({
				...this.modalDefaultUpdateSheet,
				component: ChangeUsernamePass,
				canCancel: ['escape', 'button', 'outside'],
				props: {
					idCompany: this.basicData.companyId,
					allUsers: this.allUsers,
				},
				events: {
					close: () => {
						this.fetchUsersByCompany(this.basicData.companyId).then((data) => {
							this.allUsers = data
						})
					}
				},
			});
		},
		openUploadLedgerModal() {
			this.$buefy.modal.open({
				...this.modalDefaultUpdateSheet,
				component: UploadLedger,
				// center-always-modal: helper del proyecto para centrar el card en
				// el .animation-content (sin él el modal queda descentrado).
				customClass: "center-always-modal",
				canCancel: ['escape', 'button', 'outside'],
				props: {
					idCompany: this.basicData.companyId,
				},
			});
		},
	},
	mounted() {
		if (this.basicData.oldest_join_date) {
			this.isLoading = false;
		}
	},
	watch: {
		'basicData.oldest_join_date': function (newVal) {
			if (newVal) {
				this.isLoading = false;
			}
		},
	},
};
</script>

<style scoped lang="scss">
.cbd {
	font-family: var(--ap-font);
	color: var(--ap-ink-2);
}

.cbd__grid {
	display: grid;
	grid-template-columns: minmax(0, 1.6fr) minmax(0, 1fr) minmax(0, 1fr);
	gap: 20px;
	align-items: start;
}

@media (max-width: 960px) {
	.cbd__grid {
		grid-template-columns: 1fr;
	}
}

.cbd-card {
	background: var(--ap-mist);
	border: 1px solid var(--ap-line);
	border-radius: var(--ap-radius-sm);
	padding: 20px;
}

.cbd-eyebrow {
	margin: 0;
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.08em;
	color: var(--ap-muted);
}

// ── Campos (label / valor) ────────────────────────────────────────────────
.cbd-fields {
	display: flex;
	flex-direction: column;
	gap: 16px;
	margin: 16px 0 0;
}

.cbd-field {
	display: flex;
	flex-direction: column;
	gap: 6px;
}

.cbd-field dt {
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.06em;
	color: var(--ap-muted);
}

.cbd-field dd {
	margin: 0;
	font-size: 0.9rem;
	color: var(--ap-ink);
	font-variant-numeric: tabular-nums;
}

.cbd-field__muted {
	color: var(--ap-muted);
}

// ── Contenedores de acciones ──────────────────────────────────────────────
.cbd-actions {
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
}

.cbd-actions--wrap {
	margin-top: 20px;
}

.cbd-actions--stack {
	flex-direction: column;
	flex-wrap: nowrap;
	margin-top: 16px;
}

.cbd-users {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
}

// ── Logo ──────────────────────────────────────────────────────────────────
.cbd-logo {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 12px;
	margin-top: 16px;
}

.cbd-logo__actions {
	display: flex;
	gap: 8px;
}

.company_logo {
	height: 30px;
	min-height: 30px;
	max-height: 30px;
}

// ── Estado de la conexión SII ─────────────────────────────────────────────
.cbd-sii {
	margin-top: 16px;
	padding: 12px 14px;
	border: 1px solid var(--ap-line);
	border-radius: var(--ap-radius-sm);
	background: var(--ap-paper);
}

.cbd-sii__head {
	display: flex;
	align-items: center;
	gap: 8px;
}

.cbd-sii__dot {
	width: 8px;
	height: 8px;
	border-radius: 50%;
	flex-shrink: 0;
	background: var(--ap-muted);
}

.cbd-sii__label {
	font-size: 12.5px;
	font-weight: 600;
	color: var(--ap-ink);
}

.cbd-sii__detail {
	margin: 6px 0 0;
	font-size: 12.5px;
	color: var(--ap-slate);
}

.cbd-sii__meta {
	margin: 4px 0 0;
	font-size: 11.5px;
	color: var(--ap-muted);
	font-variant-numeric: tabular-nums;
}

.cbd-sii--ok {
	border-color: rgba(15, 157, 107, 0.22);

	.cbd-sii__dot {
		background: var(--ap-ok);
	}
}

.cbd-sii--progress {
	border-color: rgba(13, 125, 128, 0.25);

	.cbd-sii__dot {
		background: var(--ap-teal);
	}
}

.cbd-sii--warn {
	border-color: rgba(200, 138, 0, 0.25);
	background: var(--ap-warn-wash);

	.cbd-sii__dot {
		background: var(--ap-warn);
	}
}

.cbd-sii--bad {
	border-color: rgba(192, 69, 59, 0.28);
	background: var(--ap-alert-wash);

	.cbd-sii__dot {
		background: var(--ap-alert);
	}
}

// ── Botones SII / Bancos (mantienen columnas de logo) ─────────────────────
.sii_b_msg {
	width: 80%;
	text-align: left;
}

.sii_logo_td {
	width: 20%;
}

.sii_logo {
	height: 2em;
	width: 4em;
	object-fit: contain;
}

// ── Theming de SimpleButton (chrome externo, no editable) ─────────────────
// SimpleButton no se puede tocar; lo alineamos al tema del analista vía
// ::v-deep sobre su clase raíz .simple_button. Píldora secundaria por defecto.
:deep(.simple_button){
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	margin: 0;
	padding: 8px 16px;
	font-family: var(--ap-font);
	font-size: 0.85rem;
	font-weight: 500;
	line-height: 1.2;
	color: var(--ap-ink-2);
	background: var(--ap-paper);
	background-image: none;
	border: 1px solid var(--ap-line-strong);
	border-radius: var(--ap-radius-pill);
	cursor: pointer;
	filter: none;
	transition: color 0.16s var(--ap-ease), border-color 0.16s var(--ap-ease),
		background-color 0.16s var(--ap-ease), transform 0.16s var(--ap-ease);

	&:hover {
		padding: 8px 16px;
		color: var(--ap-teal-deep);
		background: var(--ap-paper);
		border-color: var(--ap-teal);
		transform: translateY(-1px);
		filter: none;
	}

	&:active {
		background: var(--ap-teal-wash);
		transform: translateY(0);
	}

	&:focus-visible {
		outline: 2px solid var(--ap-teal);
		outline-offset: 2px;
	}
}

// Chips de usuario: superficie tenue, discretos.
:deep(.simple_button.user_button){
	padding: 6px 14px;
	font-size: 0.8rem;
	color: var(--ap-slate);
	background: var(--ap-mist);
	border-color: var(--ap-line);

	&:hover {
		padding: 6px 14px;
		color: var(--ap-teal-deep);
		background: var(--ap-teal-wash);
		border-color: var(--ap-teal);
	}
}

// Acción de agregar / subir: acento teal suave.
:deep(.simple_button.add_user_button){
	color: var(--ap-teal-deep);
	background: var(--ap-teal-wash);
	border-color: var(--ap-teal);

	&:hover {
		background: var(--ap-teal-wash);
		border-color: var(--ap-teal-deep);
	}
}

// Variante secundaria (botón "Ir").
:deep(.simple_button.is-secondary){
	color: var(--ap-ink-2);
	background: var(--ap-paper);
}

// Destructivo (eliminar logo).
:deep(.simple_button.btn_danger){
	padding: 8px 14px;
	color: var(--ap-alert);
	background: var(--ap-alert-wash);
	border-color: rgba(192, 69, 59, 0.28);

	&:hover {
		padding: 8px 14px;
		color: var(--ap-alert);
		background: var(--ap-alert-wash);
		border-color: rgba(192, 69, 59, 0.5);
	}
}

// En columnas apiladas los botones ocupan el ancho completo.
.cbd-actions--stack :deep(.simple_button){
	width: 100%;
	justify-content: flex-start;
}

.cbd-actions--stack :deep(.simple_button table){
	width: 100%;
	border-collapse: collapse;
}
</style>
